import type {SafeHTMLString} from '@github-ui/safe-html'
import {VerifiedHTMLText} from '@github-ui/safe-html/VerifiedHTML'
import {clsx} from 'clsx'

import styles from './SearchMatchText.module.css'

type SearchMatchTextProps = {
  /**
   * An escaped HTML string with an <em> around the matching substring.
   */
  text: SafeHTMLString

  /**
   * Optional prop to pass into the text component for fontWeight.
   */
  fontWeight?: string

  className?: string

  /**
   * BCP 47 language tag for the text content (e.g. "zh", "ja", "fr").
   * When provided, emits a `lang` attribute on the wrapping element so screen
   * readers switch to the correct voice/language for non-English content.
   * Do not pass an empty string — omit the prop entirely when the language is unknown.
   *
   * TODO: Wire backend-provided language signals into callers (e.g. a
   * `description_language` field on the search result payload) so this prop can
   * be populated automatically.
   */
  lang?: string
}

export default function SearchMatchText({text, fontWeight, className, lang}: SearchMatchTextProps) {
  const normalizedLang = lang?.trim() || undefined

  return (
    <VerifiedHTMLText
      /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
      className={clsx('search-match', styles.searchMatchText, className)}
      html={text}
      style={fontWeight ? {fontWeight} : undefined}
      lang={normalizedLang}
    />
  )
}
